import { createAction, props } from '@ngrx/store';
import {ItemTypeClass} from '@emm/core/models/item-type-class.model';

// TODO: look into converting this just to a list stored inside item-types
export enum ItemTypeClassesAction {
    Load = '[Item Types Management] Load Item Type Classes',
    LoadSuccess = '[Management API] Load Item Type Classes Success',
    LoadFailure = '[Management API] Load Item Type Classes Failure',
}

export const ItemTypeClassesActions = {
    load: createAction(ItemTypeClassesAction.Load),
    loadSuccess: createAction(ItemTypeClassesAction.LoadSuccess, props<{ itemTypeClasses: ItemTypeClass[] }>()),
    loadFailure: createAction(ItemTypeClassesAction.LoadFailure, props<{ error: any }>())
};

export const AsyncActions = {
    loadActions: [ItemTypeClassesActions.load],
    successActions: [ItemTypeClassesActions.loadSuccess],
    errorActions: [ItemTypeClassesActions.loadFailure]
};
